import {
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import { infiniteDate } from "utils";

const DatePicker = ({
  label,
  value,
  onChange,
  defaultValue,
  minDate,
  maxDate,
  width,
  disabled,
  clearable,
  ...rest
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDatePicker
        disabled={disabled}
        label={label}
        value={value || infiniteDate(value) ? moment(value) : null}
        onChange={onChange}
        minDate={minDate || moment().subtract(10, "years")}
        maxDate={maxDate && (maxDate || moment())}
        defaultValue={defaultValue}
        format={"DD MMM YYYY"}
        slotProps={{
          textField: {
            size: "small",
            style: { width: width },
            fullWidth: true,
          },
          field: { clearable },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
